import axios from 'axios';
import { config } from '@/core/config';
// import FingerprintJS from '@fingerprintjs/fingerprintjs'


export default class ApiExposedService {
    constructor() {
        // const fpPromise = FingerprintJS.load() 
        //     fpPromise
        //     .then(fp => fp.get())
        //     .then(result => {
        //     // This is the visitor identifier:
        //     const visitorId = result.visitorId
        //     //console.log("VisitorId", visitorId)
        //     axios.defaults.headers.common['VisitorId'] = visitorId;
        // })
    }
    // async getToken() {
    //     const json = {
    //         client_id: "joymeetnetqa",
    //         client_secret: "DoNotHackThisKey@joymeetnetqa",
    //         grant_type: "client_credentials"
    //     };
    //     return await axios.post(`${config.ssoClient.authority}connect/token`, json)
    //         .then(async (data: any) => {
    //             return data.access_token;
    //         });;
    // }
    //[Exposed] 取得該參與人員的事件內容
    getData(participantid: string) {
        return axios.get(`${config.apiEndPoints.jma}/exposed/event-participants/${participantid}/content`, {});
    }
    //[Exposed] 修改事件單一人員 (改為時段皆否)
    putNota(participantid: string, data: any) {
        return axios.put(`${config.apiEndPoints.jma}/event-participants/${participantid}`, data);
    }
    //[Exposed] 新增user的事件單一response Copy
    putResponse(responseid: string, data: any) {
        return axios.put(`${config.apiEndPoints.jma}/participant-responses/${responseid}`, data);
    }
    //[Exposed] 新增user的事件單一response 
    postResponse(eventid: string, data: any) {
        return axios.post(`${config.apiEndPoints.jma}/participant-responses/${eventid}`, data);
    }
    //[Exposed] 新增user的事件多個response Copy
    putMultiResponse(data: any) {
        return axios.put(`${config.apiEndPoints.jma}/participant-responses`, data);
    }
    //[Exposed] 新增user的事件單一response 
    postMultiResponse(data: any) {
        return axios.post(`${config.apiEndPoints.jma}/participant-responses`, data);
    }    
    getLog(data: FormData) {
        return axios.post(`${config.apiEndPoints.realokta}/api/Job/clicklog`, data);
    }
}

export const apiExposedService = new ApiExposedService();